import React from 'react';
//import IgniteImage from '../react-elements/IgniteImageReact';

interface Tag {
  id: number;
  name: string;
  slug: string;
}

interface MenuItemProps {
  item: {
    id: number;
    name: string;
    description: string;
    image: number;
    tags: Tag[];
  };
  activeFilters: number[];
}

const MenuItem: React.FC<MenuItemProps> = ({ item, activeFilters: stringFilters }) => {
  const activeFilters = stringFilters.map(filter => parseInt(filter.toString(), 10));
  if (!item) return null;

  // Work out if we need to apply tag filtering
  const itemTags = item.tags.map(tag => tag.id);
  const isVisible = activeFilters.length === 0 || activeFilters.every(filter => itemTags.includes(filter));

  return (
    <div 
      className={`c__menu-item transition duration-300 ${isVisible ? '' : 'wrong-tags opacity-30 pointer-events-none'}`}
      key={item.id} 
      data-tags={item.tags.map(tag => tag.id).join(',')}
    >
      {/* <div className="c__menu-item-image | hidden xl:block w-[180px] h-[180px] u__img-contain">
        {item.image && 
          <IgniteImage imageID={item.image} isWP={true} />
        }
      </div> */}
      <h3 className="text-black text-xl font-bold font-mono capitalize leading-snug mb-4">{item.name}</h3>
      {item.tags && item.tags.length > 0 && (
        <div className="c__menu-item-tags | hidden flex gap-x-3 mb-4">
          {item.tags.filter(tag => tag.display_on_menu_items).map((tag, tagIndex) => (
            <span key={tagIndex} className="c__menu-item-tag | inline-block w-[30px] h-[30px] grid text-center items-center text-white text-[15px] font-normal font-copy leading-loose bg-red rounded-full">
              {tag.display_label ? tag.display_label : tag.name.charAt(0)}
            </span>
          ))}
        </div>
      )}
      <p className="text-black/90 text-[15px] font-normal font-mono leading-snug tracking-wide max-w-[380px]">{item.description}</p>
    </div>
  );
};

export default MenuItem;